import Price from '~/libs/Price';

import { ComparativePrice } from './ComparativePrice';
import { mapComparativePriceProduct, RawComparativePriceProduct } from './mapComparativePriceProduct';

export interface RawComparativePrice {
	readonly currency: string;
	readonly fromProducts: RawComparativePriceProduct[];
	readonly value: string;
}

export const mapComparativePrice = (comparativePrice: RawComparativePrice) =>
	new ComparativePrice(
		new Price(comparativePrice.value, comparativePrice.currency),
		comparativePrice.fromProducts.map(mapComparativePriceProduct)
	);
